module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-multiselect",
    class: _vm.containerClass
  }, [_c('div', {
    staticClass: "multiselect-input",
    class: _vm.inputClass,
    on: {
      "click": _vm.focusInput
    }
  }, [_c('div', {
    staticClass: "selected-items"
  }, [_vm._l((_vm.selectedItems), function(item, index) {
    return _c('span', {
      key: index,
      staticClass: "selected-tag",
      class: _vm.tagClass
    }, [_vm._v("\n        " + _vm._s(item.text) + "\n        "), _c('span', {
      staticClass: "remove-icon",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.removeItem(item)
        }
      }
    }, [_vm._v("×")])])
  }), _vm._v(" "), (_vm.isOpen || _vm.searchQuery) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchQuery),
      expression: "searchQuery"
    }],
    ref: "searchInput",
    staticClass: "inline-search",
    attrs: {
      "type": "text",
      "placeholder": _vm.selectedItems.length === 0 ? _vm.placeholder : 'Search...'
    },
    domProps: {
      "value": (_vm.searchQuery)
    },
    on: {
      "keydown": _vm.handleKeydown,
      "blur": _vm.handleBlur,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchQuery = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.selectedItems.length === 0 && !_vm.isOpen && !_vm.searchQuery) ? _c('span', {
    staticClass: "placeholder"
  }, [_vm._v("\n        " + _vm._s(_vm.placeholder) + "\n      ")]) : _vm._e()], 2), _vm._v(" "), _c('span', {
    staticClass: "dropdown-arrow",
    class: {
      'open': _vm.isOpen
    },
    on: {
      "click": _vm.toggleDropdown
    }
  }, [_vm._v("▼")])]), _vm._v(" "), (_vm.isOpen) ? _c('div', {
    staticClass: "dropdown-options"
  }, [(_vm.multiple && _vm.options.length > 0) ? _c('div', {
    staticClass: "action-buttons"
  }, [_c('button', {
    staticClass: "action-btn select-all-btn",
    attrs: {
      "type": "button",
      "disabled": _vm.allSelected
    },
    on: {
      "click": _vm.selectAll
    }
  }, [_vm._v("\n        Select All\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "action-btn clear-all-btn",
    attrs: {
      "type": "button",
      "disabled": _vm.selectedItems.length === 0
    },
    on: {
      "click": _vm.clearAll
    }
  }, [_vm._v("\n        Clear All\n      ")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.filteredOptions), function(option) {
    return _c('div', {
      key: option.value,
      staticClass: "dropdown-option",
      class: {
        'selected': _vm.isSelected(option)
      },
      on: {
        "click": function($event) {
          _vm.toggleOption(option)
        }
      }
    }, [_c('span', {
      staticClass: "option-text"
    }, [_vm._v(_vm._s(option.text))]), _vm._v(" "), (_vm.isSelected(option)) ? _c('span', {
      staticClass: "check-icon"
    }, [_vm._v("✓")]) : _vm._e()])
  }), _vm._v(" "), (_vm.filteredOptions.length === 0) ? _c('div', {
    staticClass: "no-results"
  }, [_vm._v("\n      No options found\n    ")]) : _vm._e()], 2) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bc6a738c","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/common/CustomMultiSelect.vue
// module id = 2848
// module chunks = 0